import { render, staticRenderFns } from "./Lottie.vue?vue&type=template&id=5a960808&lang=pug&"
import script from "./Lottie.vue?vue&type=script&lang=ts&"
export * from "./Lottie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports